import {useState} from "react";
import {IFileData} from "@shared/specialComponents/FileInputEntry.tsx";

export const templatesUri = {
    ['recurso']: {
        ['import-example']: '/recurso/import-recurso.csv',
    },
    ['usuario']: {
        ['import-example']: '/usuario/import-usuario.csv',
    },
    ['empresa']: {
        ['import-example']: '/empresa/import-empresa.csv',
    },
    ['conta-contabil']: {
        ['import-example']: '/conta-contabil/import-conta-contabil.csv',
    },
    ['produto']: {
        ['import-example']: '/produto/import-produto.csv',
    },
    ['fornecedor']: {
        ['import-example']: '/fornecedor/import-fornecedor.csv',
    }
} as const


export function usePublic() {
    const [prefix] = useState('/templates');

    const getPublicTemplate = (template: keyof typeof templatesUri, value: keyof typeof templatesUri[keyof typeof templatesUri]) => {
        return prefix + templatesUri[template][value]
    }

    const importFromFile = async <T>(fileData: IFileData) => {
        const file = fileData.file;
        if (!file) return [];

        // Lê o arquivo de forma assíncrona usando Promise
        const csv = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve((reader.result as string) ?? '');
            reader.onerror = () => reject(reader.error);
            reader.readAsText(file);
        });

        // Normaliza quebras de linha e ignora linhas vazias
        const lines = csv.split(/\r?\n/).filter(l => l.trim().length > 0);
        if (lines.length === 0) return [];

        const headers = lines[0]
            .split(';')
            .map(h => h.trim())
            .filter(Boolean);

        return lines.slice(1).map(line => {
            const values = line.split(';');
            const obj: Record<string, string> = {};
            headers.forEach((header, index) => {
                obj[header] = values[index];
            });

            return obj as unknown as T;
        });
    }


    return {templates: templatesUri, getTemplate: getPublicTemplate, importFromFile}
}

export default usePublic